// this file is generated by update_shopify_store_data.py at 2026-02-23 20:32:46.699491
var categories = {
    "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C1": {
        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C1",
        "course_category_name": "Audience",
        "course_category_description": "Course Audience",
        "is_system_course_category": 0,
        "children": {
            "7D6135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 7
            },
            "D06135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician (MD/DO)",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 23
            },
            "D26135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pharmacist",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 4
            },
            "FD6135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "FD6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Occupational Therapist",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 32
            },
            "FE6135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "FE6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physical Therapist",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 32
            },
            "FFCE8697-03C9-E511-8771-005056B104B1": {
                "course_category_id": "FFCE8697-03C9-E511-8771-005056B104B1",
                "course_category_name": "Non-Clinical Professional",
                "course_category_description": "A non-clinical professional is an individual who works in a healthcare or other professional setting but does not provide direct patient care, diagnosis, or treatment. These roles support the primary clinical functions by handling tasks in administration, management, technology, finance, and other areas that keep the organization running.",
                "is_system_course_category": 0,
                "count": 4
            },
            "0DFB1B0D-04C9-E511-8771-005056B104B1": {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "course_category_description": "Allied Health Professions are a distinct group of health professionals who apply their expertise to prevent disease transmission, diagnose, treat and rehabilitate people of all ages and all specialties. Together with a range of technical and support staff they may deliver direct patient care, rehabilitation, treatment, diagnostics and health improvement interventions to restore and maintain optimal physical, sensory, psychological, cognitive and social functions.",
                "is_system_course_category": 0,
                "count": 53
            },
            "4F027BAC-08C9-E511-8771-005056B104B1": {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 41
            },
            "174D66F6-0AC9-E511-8771-005056B104B1": {
                "course_category_id": "174D66F6-0AC9-E511-8771-005056B104B1",
                "course_category_name": "Counselor/Therapist",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "6CAD973E-1DC9-E511-8771-005056B104B1": {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 6
            },
            "C98E2D7E-1EC9-E511-8771-005056B104B1": {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 9
            },
            "1F4B1A8B-1EC9-E511-8771-005056B104B1": {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 12
            },
            "B3A99091-1EC9-E511-8771-005056B104B1": {
                "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 17
            },
            "43D048A0-1EC9-E511-8771-005056B104B1": {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 248
            },
            "7C6F7677-8F9E-E511-9627-005056B1456A": {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 78
            },
            "787C7F5C-979E-E511-9627-005056B1456A": {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 288
            },
            "4DCCDD5D-E203-E911-90AD-005056B14D10": {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "DD9181A3-DF03-E911-AB1A-005056B14F90": {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 3
            },
            "D2215BC8-20DF-E511-B3E9-005056B150D3": {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 10
            },
            "19D0098D-A6BA-E811-82BD-005056B17C80": {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 13
            }
        }
    },
    "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C2": {
        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C2",
        "course_category_name": "Specialty",
        "course_category_description": "Course Specialty",
        "is_system_course_category": 0,
        "children": {
            "FCA35D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "FCA35D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Anesthesiology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 3
            },
            "03A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 24
            },
            "07A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "07A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Critical Care Medicine",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "15A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "15A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Gastroenterology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "18A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "18A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Geriatrics",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "29A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "29A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Management",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 49
            },
            "2CA45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "2CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Nephrology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "2DA45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 5
            },
            "3CA45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 14
            },
            "3DA45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 80
            },
            "41A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "48A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "48A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Radiology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 17
            },
            "52A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "56A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "56A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Urology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "62A45D8A-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "62A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Orthopedic Surgery",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 9
            },
            "C2700E93-75D8-11DC-8D1C-001517135401": {
                "course_category_id": "C2700E93-75D8-11DC-8D1C-001517135401",
                "course_category_name": "Nuclear Medicine",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 18
            },
            "B262E546-23C9-E511-8771-005056B104B1": {
                "course_category_id": "B262E546-23C9-E511-8771-005056B104B1",
                "course_category_name": "Adolescent Health",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "0A2A275A-23C9-E511-8771-005056B104B1": {
                "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "course_category_description": "was Adult Behavioral Health",
                "is_system_course_category": 0,
                "count": 96
            },
            "311E9BEF-23C9-E511-8771-005056B104B1": {
                "course_category_id": "311E9BEF-23C9-E511-8771-005056B104B1",
                "course_category_name": "Community Health",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 5
            },
            "DBCB64F6-23C9-E511-8771-005056B104B1": {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 72
            },
            "34CFCC0F-25C9-E511-8771-005056B104B1": {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 13
            },
            "0BB4475A-25C9-E511-8771-005056B104B1": {
                "course_category_id": "0BB4475A-25C9-E511-8771-005056B104B1",
                "course_category_name": "Gerontology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 154
            },
            "2DBA6766-25C9-E511-8771-005056B104B1": {
                "course_category_id": "2DBA6766-25C9-E511-8771-005056B104B1",
                "course_category_name": "Health Promotion and Wellness",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 5
            },
            "56EBAE7E-25C9-E511-8771-005056B104B1": {
                "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                "course_category_name": "Home Healthcare",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 15
            },
            "FB1CBC9E-25C9-E511-8771-005056B104B1": {
                "course_category_id": "FB1CBC9E-25C9-E511-8771-005056B104B1",
                "course_category_name": "Infection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 3
            },
            "5594B2CA-25C9-E511-8771-005056B104B1": {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "course_category_description": "was Neonatal",
                "is_system_course_category": 0,
                "count": 1
            },
            "EC9ADD83-29C9-E511-8771-005056B104B1": {
                "course_category_id": "EC9ADD83-29C9-E511-8771-005056B104B1",
                "course_category_name": "Pain Medicine",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "C89EA002-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 9
            },
            "8279C63B-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "8279C63B-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Primary Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 35
            },
            "087A0842-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "087A0842-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Public Health",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 8
            },
            "D68C685B-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "D68C685B-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Pulmonology",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 3
            },
            "C6B37F61-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Rehabilitation",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 69
            },
            "30FFDF6D-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "30FFDF6D-2CC9-E511-8771-005056B104B1",
                "course_category_name": "School Health",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "42C036BC-2CC9-E511-8771-005056B104B1": {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "AB0E13B0-F2FD-E611-BC44-005056B10E33": {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "3F4D9D32-F3FD-E611-BC44-005056B10E33": {
                "course_category_id": "3F4D9D32-F3FD-E611-BC44-005056B10E33",
                "course_category_name": "Correctional",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 8
            },
            "E23CFC1B-F4FD-E611-BC44-005056B10E33": {
                "course_category_id": "E23CFC1B-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Dialysis",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "23BE09FB-F5FD-E611-BC44-005056B10E33": {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 4
            },
            "A38C7BB8-5EF9-E611-B748-005056B122EA": {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "55C9834D-0286-E811-9579-005056B150D1": {
                "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                "course_category_name": "Hospice",
                "course_category_description": "Nursing Specialty",
                "is_system_course_category": 0,
                "count": 9
            },
            "4A566AD5-0186-E811-A5DD-005056B150D3": {
                "course_category_id": "4A566AD5-0186-E811-A5DD-005056B150D3",
                "course_category_name": "Pain",
                "course_category_description": "Nursing Specialty",
                "is_system_course_category": 0,
                "count": 1
            },
            "FD26E3C2-9222-EA11-AC06-005056B1522B": {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "13259F71-EC33-E611-9D73-005056B17F80": {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            }
        }
    },
    "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C4": {
        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C4",
        "course_category_name": "Content Publisher",
        "course_category_description": "Content Partner",
        "is_system_course_category": 0,
        "children": {
            "141CF818-E95A-DB11-A964-000423ACEF71": {
                "course_category_id": "141CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "DigitalMed",
                "course_category_description": "HSTM",
                "is_system_course_category": 0,
                "count": 398
            },
            "2A1CF818-E95A-DB11-A964-000423ACEF71": {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "course_category_description": "HealthStream",
                "is_system_course_category": 0,
                "count": 508
            },
            "3E9B30A9-41F4-11DC-8216-000423AF2193": {
                "course_category_id": "3E9B30A9-41F4-11DC-8216-000423AF2193",
                "course_category_name": "Echelon",
                "course_category_description": "Third Party",
                "is_system_course_category": 0,
                "count": 107
            },
            "D63F3006-A378-E311-BC09-001517135511": {
                "course_category_id": "D63F3006-A378-E311-BC09-001517135511",
                "course_category_name": "mySmartHealthcare",
                "course_category_description": "Third Party",
                "is_system_course_category": 0,
                "count": 25
            },
            "2E429D0C-4610-EE11-997D-005056A730AF": {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 4
            },
            "E04FAD9A-E915-EE11-997E-005056A7B10E": {
                "course_category_id": "E04FAD9A-E915-EE11-997E-005056A7B10E",
                "course_category_name": "HealthStream / ALEA Training",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 131
            },
            "8684B323-E09A-EF11-9996-005056A7EBB6": {
                "course_category_id": "8684B323-E09A-EF11-9996-005056A7EBB6",
                "course_category_name": "National Pharmacy Technician Association (NPTA)",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 58
            },
            "3E1E691D-0681-EB11-80DF-005056B108B1": {
                "course_category_id": "3E1E691D-0681-EB11-80DF-005056B108B1",
                "course_category_name": "Activated Insights",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 212
            }
        }
    },
    "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C7": {
        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-0000000000C7",
        "course_category_name": "HealthStream Courses - INTERNAL USE",
        "course_category_description": "HealthStream Courses - Internal Use - Used by HSTM internally to match up products and for implementation to turn them on",
        "is_system_course_category": 1,
        "children": {
            "10EA9A76-41F4-11DC-8216-000423AF2193": {
                "course_category_id": "10EA9A76-41F4-11DC-8216-000423AF2193",
                "course_category_name": "Echelon - Interdisciplinary Courses",
                "course_category_description": "SFID-01t30000000YtKb",
                "is_system_course_category": 1,
                "count": 24
            },
            "423C3E06-F96A-DB11-8DC9-00137250EF26": {
                "course_category_id": "423C3E06-F96A-DB11-8DC9-00137250EF26",
                "course_category_name": "DigitalMed - Clinical Practice Series***IAV***",
                "course_category_description": "SFID-01t30000000YtK6",
                "is_system_course_category": 1,
                "count": 398
            },
            "AA2548D5-06D3-E011-AD71-001517135351": {
                "course_category_id": "AA2548D5-06D3-E011-AD71-001517135351",
                "course_category_name": "Echelon - NMT/RT Bundle",
                "course_category_description": "SFID-01t3A000007UJZDQA4",
                "is_system_course_category": 1,
                "count": 6
            },
            "2E865BAC-02D3-DF11-A1D1-001517135511": {
                "course_category_id": "2E865BAC-02D3-DF11-A1D1-001517135511",
                "course_category_name": "echelon - ECG Series: Introduction to Basic Dysrhythmias",
                "course_category_description": "SFID-01t300000024SWJ",
                "is_system_course_category": 1,
                "count": 5
            },
            "73B60D7E-A378-E311-BC09-001517135511": {
                "course_category_id": "73B60D7E-A378-E311-BC09-001517135511",
                "course_category_name": "mySmartHealthcare",
                "course_category_description": "SFID-01t300000057GOZ",
                "is_system_course_category": 1,
                "count": 25
            },
            "FF1460A5-DE55-E311-9951-001517135721": {
                "course_category_id": "FF1460A5-DE55-E311-9951-001517135721",
                "course_category_name": "Echelon - Nursing Courses",
                "course_category_description": "SFID-01t30000004VjkI",
                "is_system_course_category": 1,
                "count": 11
            },
            "B4DD2A40-DB12-11DC-92DB-0015171C1B93": {
                "course_category_id": "B4DD2A40-DB12-11DC-92DB-0015171C1B93",
                "course_category_name": "HSTM - HealthStream EMS Program [Manage Subscribers with Content Package]",
                "course_category_description": "SFID-01t3000000YtK8AAK",
                "is_system_course_category": 1,
                "count": 70
            },
            "1D3C6975-21F8-EE11-998D-005056A70840": {
                "course_category_id": "1D3C6975-21F8-EE11-998D-005056A70840",
                "course_category_name": "HSTM - HealthStream Operating Room Protocol and Aseptic Technique for Healthcare Representatives",
                "course_category_description": "SFID-01t4V000009oTgIQAU",
                "is_system_course_category": 1,
                "count": 1
            },
            "C5AEB8CE-5E83-F011-999D-005056A726F7": {
                "course_category_id": "C5AEB8CE-5E83-F011-999D-005056A726F7",
                "course_category_name": "ED Pathway [Manage Publishing with Content Package]",
                "course_category_description": "SFID - 01tdK0000045lqPQAQ",
                "is_system_course_category": 1,
                "count": 148
            },
            "A6063707-5F83-F011-999D-005056A726F7": {
                "course_category_id": "A6063707-5F83-F011-999D-005056A726F7",
                "course_category_name": "ED Pathway Complete [Manage Publishing with Content Package]",
                "course_category_description": "SFID - 01tdK0000045lvFQAQ",
                "is_system_course_category": 1,
                "count": 148
            },
            "141C3C31-566F-EE11-9985-005056A730AF": {
                "course_category_id": "141C3C31-566F-EE11-9985-005056A730AF",
                "course_category_name": "HSTM - Adult and Aging Care Complete for Long-Term Care (Manage Publishing with Content Package)",
                "course_category_description": "SFID-01t4V000009CgEPQA0\r\nSFID-01t4V000009CgEQQA0",
                "is_system_course_category": 1,
                "count": 131
            },
            "27ED7B6D-DA9D-EE11-9986-005056A74645": {
                "course_category_id": "27ED7B6D-DA9D-EE11-9986-005056A74645",
                "course_category_name": "echelon - Point-of-Care Ultrasound Gastric Assessment",
                "course_category_description": "sfid-01t4V00000A0PdcQAF",
                "is_system_course_category": 1,
                "count": 2
            },
            "9644E467-0E3D-EE11-9985-005056A76585": {
                "course_category_id": "9644E467-0E3D-EE11-9985-005056A76585",
                "course_category_name": "HSTM - Adult and Aging Care Complete for Assisted Living (Manage Publishing with Content Package)",
                "course_category_description": "SFID-01t4V000009Cf3ZQAS\r\nSFID-01t4V000009Cf3aQAC",
                "is_system_course_category": 1,
                "count": 131
            },
            "CA0DE080-7898-EE11-9986-005056A773F1": {
                "course_category_id": "CA0DE080-7898-EE11-9986-005056A773F1",
                "course_category_name": "HSTM - Adult and Aging Care Complete for Home Health (Manage Publishing with Content Package)",
                "course_category_description": "SFID-01t4V000009zodJQAQ\r\nSFID-01t4V000009zodsQAA",
                "is_system_course_category": 1,
                "count": 131
            },
            "427CD235-2E5E-EF11-998E-005056A773F1": {
                "course_category_id": "427CD235-2E5E-EF11-998E-005056A773F1",
                "course_category_name": "HSTM - Skilled Nursing Facility Suite - Essentials (Manage Publishing with Content Package)",
                "course_category_description": "SFID-01t4V00000AAufAQAT",
                "is_system_course_category": 1,
                "count": 131
            },
            "B92FC0B9-AF4B-F011-99A4-005056A77B46": {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1361
            },
            "0CB7F938-E09A-EF11-9996-005056A7EBB6": {
                "course_category_id": "0CB7F938-E09A-EF11-9996-005056A7EBB6",
                "course_category_name": "National Pharmacy Technician Association (NPTA)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 58
            },
            "32E087BF-A22F-ED11-80F5-005056B10484": {
                "course_category_id": "32E087BF-A22F-ED11-80F5-005056B10484",
                "course_category_name": "Activated Insights - Alzheimer's Association Recognized Training [Manage Subscribers with Content Package]",
                "course_category_description": "01t4V000008fEbkQAE",
                "is_system_course_category": 1,
                "count": 7
            },
            "1E333179-0C0C-E611-9C3C-005056B10652": {
                "course_category_id": "1E333179-0C0C-E611-9C3C-005056B10652",
                "course_category_name": "HSTM - Outcomes & Indicators ***IAV***",
                "course_category_description": "SFID-01t3A000006q6OF",
                "is_system_course_category": 1,
                "count": 12
            },
            "736CD86E-6E7C-EB11-80DF-005056B108B1": {
                "course_category_id": "736CD86E-6E7C-EB11-80DF-005056B108B1",
                "course_category_name": "NRSRES - Nurse Residency - Manage with Content Package",
                "course_category_description": "SFID-01t4V000008PKu0QAG",
                "is_system_course_category": 1,
                "count": 1
            },
            "7FEA2588-4ADB-EB11-80E2-005056B108B1": {
                "course_category_id": "7FEA2588-4ADB-EB11-80E2-005056B108B1",
                "course_category_name": "HSTM - Care Essentials [Manage Subscribers with Content Package]",
                "course_category_description": "01t4V000008NODZQA4",
                "is_system_course_category": 1,
                "count": 276
            },
            "552455CB-0469-E811-B6FF-005056B10E33": {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "course_category_description": "SFID-01t4V000007pB46QAE",
                "is_system_course_category": 1,
                "count": 1439
            },
            "55CCB442-4185-E811-AE54-005056B11CD6": {
                "course_category_id": "55CCB442-4185-E811-AE54-005056B11CD6",
                "course_category_name": "Echelon - PET/CT Courses",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 3
            },
            "B3930550-4185-E811-AE54-005056B11CD6": {
                "course_category_id": "B3930550-4185-E811-AE54-005056B11CD6",
                "course_category_name": "Echelon - Sonography Courses",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 3
            },
            "ED5A1FF0-9CDC-E311-9157-005056B11EEE": {
                "course_category_id": "ED5A1FF0-9CDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Cardiology Collection",
                "course_category_description": "SFID-01t3000000589Ek",
                "is_system_course_category": 1,
                "count": 46
            },
            "319B2AF6-9CDC-E311-9157-005056B11EEE": {
                "course_category_id": "319B2AF6-9CDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Critical Care Collection",
                "course_category_description": "SFID-01t3000000589Ep",
                "is_system_course_category": 1,
                "count": 57
            },
            "419B2AF6-9CDC-E311-9157-005056B11EEE": {
                "course_category_id": "419B2AF6-9CDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Emergency Collection",
                "course_category_description": "SFID-01t3000000589Eu",
                "is_system_course_category": 1,
                "count": 78
            },
            "0D562CFC-9CDC-E311-9157-005056B11EEE": {
                "course_category_id": "0D562CFC-9CDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Medical-Surgical Collection",
                "course_category_description": "SFID-01t3000000589Ez",
                "is_system_course_category": 1,
                "count": 101
            },
            "03572CFC-9CDC-E311-9157-005056B11EEE": {
                "course_category_id": "03572CFC-9CDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Neonatal Collection",
                "course_category_description": "SFID-01t3000000589F4",
                "is_system_course_category": 1,
                "count": 18
            },
            "E02D7403-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "E02D7403-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Oncology Collection",
                "course_category_description": "SFID-01t3000000589F9",
                "is_system_course_category": 1,
                "count": 29
            },
            "CD555111-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "CD555111-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Obstetrics Collection",
                "course_category_description": "SFID-01t3000000589FE",
                "is_system_course_category": 1,
                "count": 28
            },
            "D2565111-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "D2565111-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Pediatrics Collection",
                "course_category_description": "SFID-01t3000000589FJ",
                "is_system_course_category": 1,
                "count": 20
            },
            "CD60A617-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "CD60A617-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Perioperative Collection***IAV***",
                "course_category_description": "SFID-01t3000000589FO",
                "is_system_course_category": 1,
                "count": 29
            },
            "FE60A617-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "FE60A617-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Psychiatry Collection",
                "course_category_description": "SFID-01t3000000589FT",
                "is_system_course_category": 1,
                "count": 14
            },
            "F7A35A1E-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "F7A35A1E-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Leadership & Communication Collection",
                "course_category_description": "SFID-01t3000000589FY",
                "is_system_course_category": 1,
                "count": 15
            },
            "08CA7124-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "08CA7124-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Patient Care Basics Collection",
                "course_category_description": "SFID-01t3000000589Fd",
                "is_system_course_category": 1,
                "count": 31
            },
            "B8CA7124-9DDC-E311-9157-005056B11EEE": {
                "course_category_id": "B8CA7124-9DDC-E311-9157-005056B11EEE",
                "course_category_name": "DigitalMed - Pharmacology Collection",
                "course_category_description": "SFID-01t3000000589Fs",
                "is_system_course_category": 1,
                "count": 33
            },
            "173EB7EF-1269-EA11-949C-005056B13721": {
                "course_category_id": "173EB7EF-1269-EA11-949C-005056B13721",
                "course_category_name": "ALEA - Adult and Aging Assisted Care (Manage with Content Package)",
                "course_category_description": "SFID:01t4V000007p8erQAA",
                "is_system_course_category": 1,
                "count": 131
            },
            "4FDFF513-446B-E911-87A4-005056B1394B": {
                "course_category_id": "4FDFF513-446B-E911-87A4-005056B1394B",
                "course_category_name": "SiTEL - MAO Program (with checklists)",
                "course_category_description": "SFID: 01t3A000007B3hTQAS",
                "is_system_course_category": 1,
                "count": 2
            },
            "369E3E13-C7F1-E511-A630-005056B1394B": {
                "course_category_id": "369E3E13-C7F1-E511-A630-005056B1394B",
                "course_category_name": "Echelon - Critical Care Nursing Program (CCNP)",
                "course_category_description": "sfid-01t3A000003g4jE",
                "is_system_course_category": 1,
                "count": 24
            },
            "7361099E-5649-EC11-80EB-005056B13D3F": {
                "course_category_id": "7361099E-5649-EC11-80EB-005056B13D3F",
                "course_category_name": "HSTM - Care Essentials: Management [Manage Subscribers with Content Package]",
                "course_category_description": "01t30000006F1lLAAS",
                "is_system_course_category": 1,
                "count": 74
            },
            "1F74B0A8-CB5D-EC11-80EC-005056B142B5": {
                "course_category_id": "1F74B0A8-CB5D-EC11-80EC-005056B142B5",
                "course_category_name": "HSTM - Care Essentials: Rehabilitation, Occupational and Physical Therapy [Manage Subscribers with Content Package]",
                "course_category_description": "01t3A000006sMVAQA2",
                "is_system_course_category": 1,
                "count": 90
            },
            "C92075A2-DA5D-EC11-80EC-005056B142B5": {
                "course_category_id": "C92075A2-DA5D-EC11-80EC-005056B142B5",
                "course_category_name": "HSTM - Care Essentials: Service Excellence [Manage Subscribers with Content Package]",
                "course_category_description": "01t30000006F1lBAAS",
                "is_system_course_category": 1,
                "count": 48
            },
            "C7A209F4-6D4D-E811-8CDD-005056B1456A": {
                "course_category_id": "C7A209F4-6D4D-E811-8CDD-005056B1456A",
                "course_category_name": "SiTEL - MAO Program (no checklists)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "EA12C069-3E85-E811-9771-005056B1456A": {
                "course_category_id": "EA12C069-3E85-E811-9771-005056B1456A",
                "course_category_name": "Echelon - Nursing Neuroscience",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 23
            },
            "B381B695-9E6D-EC11-80F0-005056B145B3": {
                "course_category_id": "B381B695-9E6D-EC11-80F0-005056B145B3",
                "course_category_name": "Cert Prep",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 99
            },
            "AAD78C37-8A92-ED11-8107-005056B14F81": {
                "course_category_id": "AAD78C37-8A92-ED11-8107-005056B14F81",
                "course_category_name": "Jane Microlearning - CE Unlimited Courses",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 12
            },
            "14827B3F-20D6-E811-A142-005056B15559": {
                "course_category_id": "14827B3F-20D6-E811-A142-005056B15559",
                "course_category_name": "HSTM - RepDirect Credentialing Bundle (Manage Subscribers with Content Package)",
                "course_category_description": "SFID-01t3A00000711F7QAI",
                "is_system_course_category": 1,
                "count": 1
            },
            "20A8938B-2B8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "20A8938B-2B8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Heart Blocks and Causes",
                "course_category_description": "SFID-01t3A000007jinXQAQ",
                "is_system_course_category": 1,
                "count": 1
            },
            "E67ED048-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "E67ED048-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Ventricular Dysrhythmias",
                "course_category_description": "SFID-01t3A000007jincQAA",
                "is_system_course_category": 1,
                "count": 1
            },
            "6E98355D-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "6E98355D-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Pharmacologics and Drug Classifications",
                "course_category_description": "SFID-01t3A000007jinwQAA",
                "is_system_course_category": 1,
                "count": 1
            },
            "E180516B-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "E180516B-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Lead Systems & Waveforms",
                "course_category_description": "SFID-01t3A000007jinrQAA",
                "is_system_course_category": 1,
                "count": 1
            },
            "A3748F7D-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "A3748F7D-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Sinus Dysrhythmias",
                "course_category_description": "SFID-01t3A000007jinmQAA",
                "is_system_course_category": 1,
                "count": 1
            },
            "3E020391-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "3E020391-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Pacemakers",
                "course_category_description": "SFID-01t3A000007jinNQAQ",
                "is_system_course_category": 1,
                "count": 1
            },
            "3EE3BCA0-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "3EE3BCA0-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Junctional Dysrhythmias",
                "course_category_description": "SFID-01t3A000007jinhQAA",
                "is_system_course_category": 1,
                "count": 1
            },
            "741E4FAD-2C8A-EA11-B9AB-005056B1680C": {
                "course_category_id": "741E4FAD-2C8A-EA11-B9AB-005056B1680C",
                "course_category_name": "Echelon ECG Course: Cardiac Review",
                "course_category_description": "SFID-01t3A000007jinSQAQ",
                "is_system_course_category": 1,
                "count": 1
            },
            "92FE556A-DCCD-EA11-BC55-005056B1680C": {
                "course_category_id": "92FE556A-DCCD-EA11-BC55-005056B1680C",
                "course_category_name": "HSTM - Clinical Deterioration CE Bundle ***IAV***",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "6584F77B-AB48-EC11-80E9-005056B16B79": {
                "course_category_id": "6584F77B-AB48-EC11-80E9-005056B16B79",
                "course_category_name": "HSTM - Care Essentials: Behavioral Health [Manage Subscribers with Content Package]",
                "course_category_description": "01t3A0000070tmBQAQ",
                "is_system_course_category": 1,
                "count": 149
            },
            "AE808662-FF35-E511-B0DE-005056B16BE3": {
                "course_category_id": "AE808662-FF35-E511-B0DE-005056B16BE3",
                "course_category_name": "Echelon - CT Registry Review",
                "course_category_description": "SFID-01t3A000007UJZ8QAO",
                "is_system_course_category": 1,
                "count": 5
            },
            "14D07874-FF35-E511-B0DE-005056B16BE3": {
                "course_category_id": "14D07874-FF35-E511-B0DE-005056B16BE3",
                "course_category_name": "Echelon - NMT/RE Anatomy Bundle",
                "course_category_description": "SFID-01t3A000007UJZIQA4",
                "is_system_course_category": 1,
                "count": 7
            },
            "4223118D-FF35-E511-B0DE-005056B16BE3": {
                "course_category_id": "4223118D-FF35-E511-B0DE-005056B16BE3",
                "course_category_name": "Echelon - NMT/RT Cardiovascular Program",
                "course_category_description": "SFID-01t3A000007UJZNQA4",
                "is_system_course_category": 1,
                "count": 1
            },
            "ED560E31-DDE9-ED11-80FB-005056B16DD5": {
                "course_category_id": "ED560E31-DDE9-ED11-80FB-005056B16DD5",
                "course_category_name": "Activated Insights - Home and Hospice Library [Manage Subscribers with Content Package]",
                "course_category_description": "01t30000006HvdxAAC",
                "is_system_course_category": 1,
                "count": 177
            }
        }
    },
    "C0146C9B-DC01-11DC-9164-000423AF2193": {
        "course_category_id": "C0146C9B-DC01-11DC-9164-000423AF2193",
        "course_category_name": "DBA Reporting",
        "course_category_description": "This will be used for DBA custom reports.",
        "is_system_course_category": 1,
        "children": {
            "C89BCC92-DB12-11DC-92DB-0015171C1B93": {
                "course_category_id": "C89BCC92-DB12-11DC-92DB-0015171C1B93",
                "course_category_name": "EMS - Florida CECBEMS",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 55
            },
            "7B45AC84-0D0C-E611-9C3C-005056B10652": {
                "course_category_id": "7B45AC84-0D0C-E611-9C3C-005056B10652",
                "course_category_name": "Outcomes & Indicators",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 11
            },
            "5BD2A698-5A16-EC11-80E7-005056B17014": {
                "course_category_id": "5BD2A698-5A16-EC11-80E7-005056B17014",
                "course_category_name": "NJ EMS",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 7
            }
        }
    },
    "7CCFB809-3882-E011-B8A9-001517135213": {
        "course_category_id": "7CCFB809-3882-E011-B8A9-001517135213",
        "course_category_name": "HealthStream Collections",
        "course_category_description": "",
        "is_system_course_category": 0,
        "children": {
            "19DC0D72-1085-E311-8219-0015171350B3": {
                "course_category_id": "19DC0D72-1085-E311-8219-0015171350B3",
                "course_category_name": "mySmartHealthcare",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 25
            },
            "C9CABFE2-E355-E311-9951-001517135721": {
                "course_category_id": "C9CABFE2-E355-E311-9951-001517135721",
                "course_category_name": "Echelon - Nursing Courses",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 11
            },
            "1F7509BE-E5D3-E011-B0C0-0015171C1A75": {
                "course_category_id": "1F7509BE-E5D3-E011-B0C0-0015171C1A75",
                "course_category_name": "Echelon - Interdisciplinary Courses",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 24
            },
            "EFCC29CA-E5D3-E011-B0C0-0015171C1A75": {
                "course_category_id": "EFCC29CA-E5D3-E011-B0C0-0015171C1A75",
                "course_category_name": "Echelon - NMT/RT Bundle",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 6
            },
            "0599F5AB-21F8-EE11-998D-005056A70840": {
                "course_category_id": "0599F5AB-21F8-EE11-998D-005056A70840",
                "course_category_name": "HealthStream Operating Room Protocol and Aseptic Technique for Healthcare Representatives",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "510FC225-EF7C-EE11-9987-005056A725AD": {
                "course_category_id": "510FC225-EF7C-EE11-9987-005056A725AD",
                "course_category_name": "Echelon -  Single Modules",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 4
            },
            "686E929A-DA9D-EE11-9986-005056A74645": {
                "course_category_id": "686E929A-DA9D-EE11-9986-005056A74645",
                "course_category_name": "echelon - Point-of-Care Ultrasound Gastric Assessment",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "5DA9C801-827A-EE11-9985-005056A76043": {
                "course_category_id": "5DA9C801-827A-EE11-9985-005056A76043",
                "course_category_name": "Activated Insights: Alzheimer's Association Recognized Training",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 7
            },
            "9B913F56-30F1-EE11-998B-005056A76D1A": {
                "course_category_id": "9B913F56-30F1-EE11-998B-005056A76D1A",
                "course_category_name": "Medical Assistant Orientation",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "8A98D6C7-35DB-EB11-80E2-005056B108B1": {
                "course_category_id": "8A98D6C7-35DB-EB11-80E2-005056B108B1",
                "course_category_name": "HSTM - Care Essentials",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 276
            },
            "0CCD8CED-4085-E811-AE54-005056B11CD6": {
                "course_category_id": "0CCD8CED-4085-E811-AE54-005056B11CD6",
                "course_category_name": "Echelon - PET/CT Courses",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "F58A2309-4185-E811-AE54-005056B11CD6": {
                "course_category_id": "F58A2309-4185-E811-AE54-005056B11CD6",
                "course_category_name": "Echelon - Sonography Courses",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 3
            },
            "A7B29B9D-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "A7B29B9D-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Cardiology Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 46
            },
            "B4B29B9D-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "B4B29B9D-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Clinical Practice Series",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 398
            },
            "E0EF56B0-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "E0EF56B0-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Critical Care Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 57
            },
            "09963CBD-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "09963CBD-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Emergency Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 78
            },
            "D17D6AC3-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "D17D6AC3-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Leadership & Communication Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 16
            },
            "1F3BB2D5-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "1F3BB2D5-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Medical-Surgical Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 101
            },
            "EA23AADB-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "EA23AADB-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Neonatal Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 18
            },
            "80E8A2E1-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "80E8A2E1-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Obstetrics Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 28
            },
            "19E4A8E7-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "19E4A8E7-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Oncology Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 29
            },
            "78EEA9F4-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "78EEA9F4-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Patient Care Basics Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 31
            },
            "399F4AFB-9C85-EB11-80DF-005056B134EC": {
                "course_category_id": "399F4AFB-9C85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Pediatrics Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 20
            },
            "BB80CB02-9D85-EB11-80DF-005056B134EC": {
                "course_category_id": "BB80CB02-9D85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Perioperative Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 29
            },
            "FC10830F-9D85-EB11-80DF-005056B134EC": {
                "course_category_id": "FC10830F-9D85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Pharmacology Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 33
            },
            "8C3E0A17-9D85-EB11-80DF-005056B134EC": {
                "course_category_id": "8C3E0A17-9D85-EB11-80DF-005056B134EC",
                "course_category_name": "DigitalMed - Psychiatry Collection",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 14
            },
            "0B70D3C9-1269-EA11-949C-005056B13721": {
                "course_category_id": "0B70D3C9-1269-EA11-949C-005056B13721",
                "course_category_name": "ALEA - Adult and Aging Assisted Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 131
            },
            "6AEC7631-C7F1-E511-A630-005056B1394B": {
                "course_category_id": "6AEC7631-C7F1-E511-A630-005056B1394B",
                "course_category_name": "Echelon - Critical Care Nursing Program (CCNP)",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 24
            },
            "32F96491-DE28-EB11-80D9-005056B13D3F": {
                "course_category_id": "32F96491-DE28-EB11-80D9-005056B13D3F",
                "course_category_name": "ALEA Training",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 131
            },
            "390C203E-A184-E811-A83C-005056B141CC": {
                "course_category_id": "390C203E-A184-E811-A83C-005056B141CC",
                "course_category_name": "Echelon - Nursing Neuroscience",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 23
            },
            "CCD4D13D-865E-EC11-80EB-005056B143AA": {
                "course_category_id": "CCD4D13D-865E-EC11-80EB-005056B143AA",
                "course_category_name": "Echelon \u2013 Mini Modules: ECG Fundamentals & Basic Dysrhythmias",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 8
            },
            "8241D36A-6F4D-E811-8CDD-005056B1456A": {
                "course_category_id": "8241D36A-6F4D-E811-8CDD-005056B1456A",
                "course_category_name": "MAOP Program",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "7F8CC6A3-93FC-EC11-80F9-005056B145B3": {
                "course_category_id": "7F8CC6A3-93FC-EC11-80F9-005056B145B3",
                "course_category_name": "HSTM - RepDirect Credentialing Bundle",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "31898A2C-7BDA-EB11-80E2-005056B14C8B": {
                "course_category_id": "31898A2C-7BDA-EB11-80E2-005056B14C8B",
                "course_category_name": "echelon - ECG Series: Introduction to Basic Dysrhythmias",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 5
            },
            "E64072BD-57B5-E511-827F-005056B1522B": {
                "course_category_id": "E64072BD-57B5-E511-827F-005056B1522B",
                "course_category_name": "Nurse Residency Bundle",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 5
            },
            "8B7C66DA-3338-E411-8C21-005056B1680C": {
                "course_category_id": "8B7C66DA-3338-E411-8C21-005056B1680C",
                "course_category_name": "Activated Insights: Home and Hospice Library",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 176
            },
            "782153DB-FF35-E511-B0DE-005056B16BE3": {
                "course_category_id": "782153DB-FF35-E511-B0DE-005056B16BE3",
                "course_category_name": "Echelon - CT Registry Review",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 5
            },
            "11B050F3-FF35-E511-B0DE-005056B16BE3": {
                "course_category_id": "11B050F3-FF35-E511-B0DE-005056B16BE3",
                "course_category_name": "Echelon - NMT/RE Anatomy Bundle",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 7
            },
            "115848FF-FF35-E511-B0DE-005056B16BE3": {
                "course_category_id": "115848FF-FF35-E511-B0DE-005056B16BE3",
                "course_category_name": "Echelon - NMT/RT Cardiovascular Program",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "6C5F517D-AD26-EC11-80EA-005056B17C18": {
                "course_category_id": "6C5F517D-AD26-EC11-80EA-005056B17C18",
                "course_category_name": "HSTM - EMS Program",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 70
            }
        }
    },
    "BD6BA9F2-1335-11DE-A259-001517135351": {
        "course_category_id": "BD6BA9F2-1335-11DE-A259-001517135351",
        "course_category_name": "HealthStream Courses - Internal Use - NO LONGER SOLD",
        "course_category_description": "Content Partner Contract Ended",
        "is_system_course_category": 1,
        "children": {
            "C5E0945D-F18B-EF11-9996-005056A77B46": {
                "course_category_id": "C5E0945D-F18B-EF11-9996-005056A77B46",
                "course_category_name": "z_ContentOps \u2013 Standard Evaluation Update",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 845
            },
            "F7B8230F-9537-EE11-997F-005056A78EAA": {
                "course_category_id": "F7B8230F-9537-EE11-997F-005056A78EAA",
                "course_category_name": "Activated Insights - Upskilling for Proficient Caregivers [Manage Subscribers with Content Package]",
                "course_category_description": "01t4V000008fEbgQAE",
                "is_system_course_category": 1,
                "count": 5
            },
            "C99E8F68-AB2F-ED11-80F5-005056B10484": {
                "course_category_id": "C99E8F68-AB2F-ED11-80F5-005056B10484",
                "course_category_name": "Activated Insights - Onboarding for Novice Caregivers [Manage Subscribers with Content Package]",
                "course_category_description": "01t4V000008fEbfQAE",
                "is_system_course_category": 1,
                "count": 8
            },
            "5BD4D1FA-B887-E511-A452-005056B12710": {
                "course_category_id": "5BD4D1FA-B887-E511-A452-005056B12710",
                "course_category_name": "HCP (Home Care Pulse) - CNA, HHA, and PCA Library [Manage Subscribers with Content Package]",
                "course_category_description": "01t30000006EzjCAAS",
                "is_system_course_category": 1,
                "count": 118
            },
            "16F296AD-BA4B-E711-987E-005056B12CFE": {
                "course_category_id": "16F296AD-BA4B-E711-987E-005056B12CFE",
                "course_category_name": "CE Unlimited Non-Acute (Manage Subscribers with Content Package)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "403257DB-3F91-EA11-96BA-005056B13721": {
                "course_category_id": "403257DB-3F91-EA11-96BA-005056B13721",
                "course_category_name": "HSTM - Regression, Performance, and UX Testing",
                "course_category_description": "Created to provide an internal use category for courses used in regression testing.",
                "is_system_course_category": 1,
                "count": 3
            },
            "FEA687B0-F1B1-EC11-80EE-005056B13A46": {
                "course_category_id": "FEA687B0-F1B1-EC11-80EE-005056B13A46",
                "course_category_name": "HSTM - Content Regression Testing",
                "course_category_description": "Created to provide an internal use category for courses used in CONTENT regression testing.",
                "is_system_course_category": 1,
                "count": 3
            },
            "B999633B-FD8E-E511-8AF2-005056B1522B": {
                "course_category_id": "B999633B-FD8E-E511-8AF2-005056B1522B",
                "course_category_name": "In The Know - CNA Library - UNtimed Version",
                "course_category_description": "SFID-01t30000006F2TI",
                "is_system_course_category": 1,
                "count": 2
            },
            "8E268A1D-87DB-E311-A041-005056B1680C": {
                "course_category_id": "8E268A1D-87DB-E311-A041-005056B1680C",
                "course_category_name": "CE Unlimited Clinician: Extended (Manage Subscribers with Content Package)",
                "course_category_description": "SFID-",
                "is_system_course_category": 1,
                "count": 2
            },
            "CDFAE764-A998-EB11-80E0-005056B17014": {
                "course_category_id": "CDFAE764-A998-EB11-80E0-005056B17014",
                "course_category_name": "IHA Cabrini Bundle (Manage Subscribers with Content Package) (retired 2/10/2025)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 39
            }
        }
    },
    "EFD4F4F1-4094-11DE-AC59-001517135401": {
        "course_category_id": "EFD4F4F1-4094-11DE-AC59-001517135401",
        "course_category_name": "zzDelete",
        "course_category_description": "",
        "is_system_course_category": 1,
        "children": {
            "CE6135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "CE6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Pathologist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "D86135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Respiratory Therapist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 4
            },
            "F66135AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "F66135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Administrators",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "096235AD-E357-DB11-A8F9-000423ACEF71": {
                "course_category_id": "096235AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Radiologic Technologist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "4E93A1E9-2688-11DD-914D-0015171C1A75": {
                "course_category_id": "4E93A1E9-2688-11DD-914D-0015171C1A75",
                "course_category_name": "zRemoved-Social Worker",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 38
            },
            "8751B0FD-B46F-EF11-9991-005056A7F5E9": {
                "course_category_id": "8751B0FD-B46F-EF11-9991-005056A7F5E9",
                "course_category_name": "zRemoved-Unlicensed Assistive Personnel",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "90B55558-03C9-E511-8771-005056B104B1": {
                "course_category_id": "90B55558-03C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Urgent Care",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 22
            },
            "584A612F-08C9-E511-8771-005056B104B1": {
                "course_category_id": "584A612F-08C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Child, Family, and School Social Worker",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "BCD39275-08C9-E511-8771-005056B104B1": {
                "course_category_id": "BCD39275-08C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Chiropractor",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "4795FB54-0BC9-E511-8771-005056B104B1": {
                "course_category_id": "4795FB54-0BC9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Diagnostic Medical Sonographer",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "32964569-0BC9-E511-8771-005056B104B1": {
                "course_category_id": "32964569-0BC9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Dietitian and Nutritionist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "20D02A7A-1DC9-E511-8771-005056B104B1": {
                "course_category_id": "20D02A7A-1DC9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Magnetic Resonance Imaging Technologist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "40AC33B7-1DC9-E511-8771-005056B104B1": {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Medical Assistant",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 3
            },
            "927903E9-1DC9-E511-8771-005056B104B1": {
                "course_category_id": "927903E9-1DC9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Mental Health and Substance Abuse Social Worker",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 64
            },
            "97B2F277-1EC9-E511-8771-005056B104B1": {
                "course_category_id": "97B2F277-1EC9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Nuclear Medicine Technologist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "07CABD07-20C9-E511-8771-005056B104B1": {
                "course_category_id": "07CABD07-20C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Occupational Therapy Assistant",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "56A330E9-20C9-E511-8771-005056B104B1": {
                "course_category_id": "56A330E9-20C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Personal Care and Service Worker, All Other",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 10
            },
            "9EF12408-21C9-E511-8771-005056B104B1": {
                "course_category_id": "9EF12408-21C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Phlebotomist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "A446FF3A-21C9-E511-8771-005056B104B1": {
                "course_category_id": "A446FF3A-21C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Physical Therapist Aide",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "B34E0A4E-21C9-E511-8771-005056B104B1": {
                "course_category_id": "B34E0A4E-21C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Physical Therapist Assistant",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "49C9DEAB-21C9-E511-8771-005056B104B1": {
                "course_category_id": "49C9DEAB-21C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Radiation Therapist",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 5
            },
            "5CE566BE-21C9-E511-8771-005056B104B1": {
                "course_category_id": "5CE566BE-21C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Radiologic Technician",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "E8A2EF17-22C9-E511-8771-005056B104B1": {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Respiratory Therapy Technician",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "2C0C3F31-22C9-E511-8771-005056B104B1": {
                "course_category_id": "2C0C3F31-22C9-E511-8771-005056B104B1",
                "course_category_name": "zRemoved-Sales Representative",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            },
            "53BDC683-A6BA-E811-82BD-005056B17C80": {
                "course_category_id": "53BDC683-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "zRemoved-Radiology Practitioner Assistant",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            }
        }
    },
    "B25E5D6C-D100-E111-8FB9-001517135721": {
        "course_category_id": "B25E5D6C-D100-E111-8FB9-001517135721",
        "course_category_name": "HealthStream Courses - Internal Use - HSTM Product Training and ContentOps Only",
        "course_category_description": "This category should be used for two things: \r\n1. Product Training courses (training customers how to use HSTM products).\r\n2. Organization specific to Content Operations.",
        "is_system_course_category": 1,
        "children": {
            "78ADD00E-FDC9-E511-83FE-005056B12B9C": {
                "course_category_id": "78ADD00E-FDC9-E511-83FE-005056B12B9C",
                "course_category_name": "HSTM - Cert Prep Study Cards",
                "course_category_description": "SFID: 01t3A000007YP9pQAG",
                "is_system_course_category": 1,
                "count": 50
            },
            "23085E2D-CA53-E811-A449-005056B12CFE": {
                "course_category_id": "23085E2D-CA53-E811-A449-005056B12CFE",
                "course_category_name": "HSTM - CE Channel",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 5
            }
        }
    },
    "C5C76B9F-2576-11DF-A530-0015171C1A75": {
        "course_category_id": "C5C76B9F-2576-11DF-A530-0015171C1A75",
        "course_category_name": "HealthStream Courses - Internal Use - Custom Content, hStream, and MedTech",
        "course_category_description": "",
        "is_system_course_category": 1,
        "children": {
            "0B8DB65A-4901-E811-8423-005056B144C5": {
                "course_category_id": "0B8DB65A-4901-E811-8423-005056B144C5",
                "course_category_name": "CE Unlimited: AMN Only (Manage Subscribers with Content Package)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 584
            }
        }
    },
    "1523CA33-40B4-DF11-9F38-0015171C5BB1": {
        "course_category_id": "1523CA33-40B4-DF11-9F38-0015171C5BB1",
        "course_category_name": "CE Credit",
        "course_category_description": "",
        "is_system_course_category": 0,
        "children": {
            "E24BC24C-40B4-DF11-9F38-0015171C5BB1": {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "DFE5D158-40B4-DF11-9F38-0015171C5BB1": {
                "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CE - Continuing Education",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 38
            }
        }
    },
    "990EFACB-CC96-EF11-998E-005056A7DAD4": {
        "course_category_id": "990EFACB-CC96-EF11-998E-005056A7DAD4",
        "course_category_name": "HealthStream Courses - Internal Use - eCommerce_B2P - CONTENTOPS USE ONLY",
        "course_category_description": "See subcategories for different B2P sites.",
        "is_system_course_category": 1,
        "children": {
            "E9F2741E-47EE-EF11-9995-005056A726F7": {
                "course_category_id": "E9F2741E-47EE-EF11-9995-005056A726F7",
                "course_category_name": "NurseGrid Learn - a la carte - OVERLAP [Use UNCE CPP for role-based publish]",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 21
            },
            "FA1EE78C-235A-ED11-80F7-005056B10BDD": {
                "course_category_id": "FA1EE78C-235A-ED11-80F7-005056B10BDD",
                "course_category_name": "NurseGrid Learn - Unlimited CE Library (subscription) (Publish with CPP)",
                "course_category_description": "SFID-01t4V000008gMbmQAE",
                "is_system_course_category": 1,
                "count": 1393
            }
        }
    },
    "0181D983-B841-E811-A76A-005056B10493": {
        "course_category_id": "0181D983-B841-E811-A76A-005056B10493",
        "course_category_name": "CE Unlimited",
        "course_category_description": "Created 4/16/2018 to allow dev work on new product.  Name subject to change.  Do not delete.",
        "is_system_course_category": 0,
        "children": {
            "112BCFC6-FD52-E811-85F6-005056B15559": {
                "course_category_id": "112BCFC6-FD52-E811-85F6-005056B15559",
                "course_category_name": "Challenge Tracks",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 5
            }
        }
    },
    "F31879DE-FAC5-E511-A007-005056B1318B": {
        "course_category_id": "F31879DE-FAC5-E511-A007-005056B1318B",
        "course_category_name": "Setting",
        "course_category_description": "",
        "is_system_course_category": 0,
        "children": {
            "8433B687-264F-DB11-9011-000423ACEF71": {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "course_category_description": "was Emergency Medical Services",
                "is_system_course_category": 0,
                "count": 9
            },
            "B9B7575F-02C9-E511-8771-005056B104B1": {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 3
            },
            "4D1B82BB-02C9-E511-8771-005056B104B1": {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 117
            },
            "A5538AC7-02C9-E511-8771-005056B104B1": {
                "course_category_id": "A5538AC7-02C9-E511-8771-005056B104B1",
                "course_category_name": "Residential and Long Term Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 64
            },
            "655F6BE8-02C9-E511-8771-005056B104B1": {
                "course_category_id": "655F6BE8-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pharmacy",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "1CD0D551-03C9-E511-8771-005056B104B1": {
                "course_category_id": "1CD0D551-03C9-E511-8771-005056B104B1",
                "course_category_name": "Telehealth",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            },
            "BF92C7B7-00C9-E511-BC00-005056B1263C": {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 82
            },
            "EB0C13C7-0116-EA11-8041-005056B15B8C": {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 232
            },
            "B63F27E3-07FE-E611-A7FF-005056B16BE3": {
                "course_category_id": "B63F27E3-07FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Billing/Management/Consulting",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            },
            "0232F723-0AFE-E611-A7FF-005056B16BE3": {
                "course_category_id": "0232F723-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Transport",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 1
            }
        }
    },
    "163802F8-B1F3-EB11-80E4-005056B134EC": {
        "course_category_id": "163802F8-B1F3-EB11-80E4-005056B134EC",
        "course_category_name": "Course Developer - for internal use only",
        "course_category_description": "This is for keeping track of who created the courses and would be able to fix or update files. Use this if we work directly with that developer.",
        "is_system_course_category": 1,
        "children": {
            "AFF0FB5D-3C6A-EB11-80DE-005056B134EC": {
                "course_category_id": "AFF0FB5D-3C6A-EB11-80DE-005056B134EC",
                "course_category_name": "True Vector (Aspenti) - Care Essentials",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 648
            },
            "30824C37-B2F3-EB11-80E4-005056B134EC": {
                "course_category_id": "30824C37-B2F3-EB11-80E4-005056B134EC",
                "course_category_name": "ansrsource",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 70
            },
            "D8EB073A-B3F3-EB11-80E4-005056B134EC": {
                "course_category_id": "D8EB073A-B3F3-EB11-80E4-005056B134EC",
                "course_category_name": "Laura Quinn",
                "course_category_description": "Laura used to work for Ed4, then helped us to build the courses in the Senior Care Complete library.",
                "is_system_course_category": 1,
                "count": 131
            },
            "A5A31B74-8028-EC11-80E8-005056B142C1": {
                "course_category_id": "A5A31B74-8028-EC11-80E8-005056B142C1",
                "course_category_name": "Content Operations",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 2
            }
        }
    },
    "199AFF64-A6F8-E311-A9A9-005056B14441": {
        "course_category_id": "199AFF64-A6F8-E311-A9A9-005056B14441",
        "course_category_name": "zObsolete Categories",
        "course_category_description": "Use this for any category that should no longer display for users.",
        "is_system_course_category": 1,
        "children": {
            "1BD5033E-033C-E311-9D96-0015171C1B93": {
                "course_category_id": "1BD5033E-033C-E311-9D96-0015171C1B93",
                "course_category_name": "No Credit",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 5
            },
            "6FE62742-DA66-E011-AAC8-0015171C5BB3": {
                "course_category_id": "6FE62742-DA66-E011-AAC8-0015171C5BB3",
                "course_category_name": "American Nurses Credentialing Center (ANCC)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 76
            }
        }
    },
    "82BCC732-E409-E811-AF76-005056B1680C": {
        "course_category_id": "82BCC732-E409-E811-AF76-005056B1680C",
        "course_category_name": "Content Type",
        "course_category_description": "",
        "is_system_course_category": 0,
        "children": {
            "0D029A6E-0C11-E811-96E0-005056B12696": {
                "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                "course_category_name": "Course",
                "course_category_description": "",
                "is_system_course_category": 0,
                "count": 2
            }
        }
    },
    "597A53B9-3FD6-EC11-80F1-005056B17FCD": {
        "course_category_id": "597A53B9-3FD6-EC11-80F1-005056B17FCD",
        "course_category_name": "Duplicated Courses (Internal ONLY)",
        "course_category_description": "This category is for the purposes of ContentOps to track courses that are being duplicated for use in multiple products.",
        "is_system_course_category": 1,
        "children": {
            "9F35A29A-DE3A-EE11-9981-005056A740BF": {
                "course_category_id": "9F35A29A-DE3A-EE11-9981-005056A740BF",
                "course_category_name": "Parent: Activated Insights",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 4
            },
            "67D6D811-69BC-EE11-9987-005056A74645": {
                "course_category_id": "67D6D811-69BC-EE11-9987-005056A74645",
                "course_category_name": "Parent: Cert Prep",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 4
            },
            "1DA8C9B8-79BC-EE11-9987-005056A74645": {
                "course_category_id": "1DA8C9B8-79BC-EE11-9987-005056A74645",
                "course_category_name": "Parent: HSTM - Outcomes and Indicators",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 12
            },
            "EAC228B6-CB60-F011-999A-005056A74A17": {
                "course_category_id": "EAC228B6-CB60-F011-999A-005056A74A17",
                "course_category_name": "Parent: NPTA",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 20
            },
            "2A07B705-5F11-F011-9995-005056A7C0C7": {
                "course_category_id": "2A07B705-5F11-F011-9995-005056A7C0C7",
                "course_category_name": "Parent: CE Unlimited",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 1
            },
            "781F2D85-ECD4-EE11-998A-005056A7D719": {
                "course_category_id": "781F2D85-ECD4-EE11-998A-005056A7D719",
                "course_category_name": "Parent: HSTM - CE by State",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 7
            },
            "F0B31195-ADF0-EC11-80F1-005056B13A46": {
                "course_category_id": "F0B31195-ADF0-EC11-80F1-005056B13A46",
                "course_category_name": "Parent: Echelon - ALL (Std Credits)",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 9
            },
            "360A5EC8-40D6-EC11-80F1-005056B17FCD": {
                "course_category_id": "360A5EC8-40D6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: HSTM - DigitalMed",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 6
            },
            "691B1913-41D6-EC11-80F1-005056B17FCD": {
                "course_category_id": "691B1913-41D6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: HSTM - Care Essentials",
                "course_category_description": "",
                "is_system_course_category": 1,
                "count": 6
            }
        }
    }
};